import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class UserService {
  base_url: string = DDP_ENV.userUrl;
  constructor(private _router: Router, private _http: Http, private cookieService: CookieService) {

  }
  /****************************** User activity ******************************************/
	/* Get user */
  getUser(userId: string): Observable<any> {
    return this._http.get(this.base_url + '/user/' + userId, this.buildHeaders()).map((res: Response) => res.json());
  }
  /* Get users */
  getUsers(): Observable<any> {
    return this._http.get(this.base_url + '/user', this.buildHeaderswithPageAndSize()).map((res: Response) => res.json()); }
    /* save users */
  saveUser(user: any): Observable<any> {
    return this._http.post(this.base_url + '/user/register', user, this.buildHeaders())
      .map((res: Response) => {
        return res.json(); });
    }

  /* Update users */
  updateUser(user, client_id): Observable<any> {
    return this._http.post(this.base_url + '/user/' + user.id + '/' + client_id, user, this.buildHeaders())
      .map((res: Response) => {
        return res.json();
      });
  }

  /* Change password */
  changePassword(id, password): Observable<any> {
    return this._http.put(this.base_url + '/user/' + id + '/password', password, this.buildHeaders())
      .map((res: Response) => {
        return res.json();
      });
  }

  /* Delete an user */
  deleteUser(userId): Observable<any> {
    return this._http.put(this.base_url + '/user/' + userId + '/block', this.buildHeaders())
      .map((res: Response) => {
        return res.json();
      });
  }

  /* Unblock an user */
  unblockUser(userId): Observable<any> {
    return this._http.put(this.base_url + '/user/' + userId + '/unblock', this.buildHeaders())
      .map((res: Response) => {
        return res.json();
      });
  }

  /* Resend mail */
  resendConfirmationEmail(userName): Observable<any> {
    return this._http.get(this.base_url + '/user/' + userName + '/resend/confirmation/' + userName, this.buildHeaders())
      .map((res: Response) => res.json());
  }

  /* Reset passwors */
  resetPassword(userName): Observable<any> {
    return this._http.get(this.base_url + '/user/' + userName + '/reset/password/', this.buildHeaders())
      .map((res: Response) => res.json());
  }


  getUserByUserName(userName): Observable<any> {
    return this._http.get(this.base_url + '/user/' + userName, this.buildHeadersWithRegx(userName))
      .map((res: Response) => res.json());
  }


    /****************************** Roles and permission ***********************************/
    /* Get user roles */
  getAllRoles(userId: string): Observable<any> {
    return this._http.get(this.base_url + '/user/role', this.buildHeadersForRoles())
      .map((res: Response) => res.json());
  }


  /* Get permissions */
  getAllPermission(): Observable<any> {
    return this._http.get(this.base_url + '/permission', this.buildHeaderswithPageAndSize())
      .map((res: Response) => res.json());
  }


  /* Get OneRolePermission */
  getOneRolePermission(roleId: string): Observable<any> {
    return this._http.get(this.base_url + '/user/role/' + roleId, this.buildHeaderswithPageAndSize())
      .map((res: Response) => res.json());
  }

  /* Get getMonitoringUsers */
  getMonitoringUsers(user: any): Observable<any> {
    return this._http.get(this.base_url + '/monitoring/user/' + user.id, this.buildHeaderswithPageAndSize())
      .map((res: Response) => res.json());
  }

  /* Search */
  search(regexPattern, page, size, isActive): Observable<any> {
    return this._http.get(this.base_url + '/user', this.buildHeadersForSearch(regexPattern, page, size, isActive))
      .map((res: Response) => res.json());
  }


  /****************************** Create headers ******************************************/
  /* Build request header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }

  /* Build request header for user */
  private buildHeaderswithPageAndSize(): any {
    const params = new HttpParams()
      .set('page', '0')
      .set('size', '9999999');
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')
      , 'client-id': localStorage.getItem('clientId')});
    return new RequestOptions({ headers: headers, params: params });
  }

  /* Build request header for roles */
  private buildHeadersForRoles(): any {
    const params = new HttpParams()
      .set('page', '0')
      .set('size', '9999999')
      .set('ecFall', 'true');
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers, params: params });
  }

  /* Build request header for search */
  private buildHeadersForSearch(regexPattern, page, size, isActive): any {
    page = page || 0;
    size = size || 9999999;
    const params = new HttpParams()
      .set('page', page)
      .set('size', size)
      .set('isActive', isActive)
      .set('regexPattern', regexPattern);
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers, params: params });
  }

  /* Build request header for user */
  private buildHeadersWithRegx(regexPattern): any {
    const params = new HttpParams()
      .set('regexPattern', regexPattern);
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers, params: params });
  }
}
